module.exports = "/shifts/components/applicantRowContentComponent-f2e98e.html";